import { render, staticRenderFns } from "./TabelaRevendedores.vue?vue&type=template&id=1ecf7292&scoped=true"
import script from "./TabelaRevendedores.vue?vue&type=script&lang=js"
export * from "./TabelaRevendedores.vue?vue&type=script&lang=js"
import style0 from "./TabelaRevendedores.vue?vue&type=style&index=0&id=1ecf7292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf7292",
  null
  
)

export default component.exports